/* eslint-disable prefer-template */
import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { toast } from 'react-toastify';
import PeopleIcon from '@material-ui/icons/People';
import SaveAlt from '@material-ui/icons/SaveAlt';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Paper from '~/components/Paper';
import Button from '~/components/Button';
import Table from '~/components/Table/Table';
import GridItem from '~/components/GridItem';
import InputDate from '~/components/Input/InputDate';
import GridContainer from '~/components/GridContainer';
import LinearProgress from '~/components/LinearProgress';
import tableStyles from '~/components/Table/Table/styles';
import InputControl from '~/components/Input/InputControl';
import InputSelectAsync from '~/components/Input/InputSelectAsync';
import TablePagination from '~/components/Table/TablePagination';
import Request from '~/providers/Request';
import toInt from '~/utils/Number/toInt';
import isPresent from '~/utils/isPresent';
import csvGenerator from '~/utils/csvGenerator';
import xlsxGenerator from '~/utils/xlsxGenerator';
import InputSwitch from '~/components/Input/InputSwitch';
import CurrentUser from '~/contexts/CurrentUser';

import { fetchHolders } from '~/utils/fetchHolders';
import { fetchCardOwnersAssas } from '../../../utils/fetchCardOwnersAsaas';
import { Tooltip } from '@material-ui/core';

function ReportsAsaas() {
  const { t } = useTranslation();
  const classesTable = tableStyles();
  const { user } = useContext(CurrentUser);
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [totalReports, setTotalReports] = useState(0);
  const [holderName, setHolderName] = useState(null);
  const [dataInit, setDataInit] = useState(moment().startOf('month').format());
  const [dataEnd, setDataEnd] = useState(moment().endOf('month').format());
  const [notUsedDaysAfter, setNotUsedDaysAfter] = useState(false);
  const [notRenewedAfterAcquire, setNotRenewedAfterAcquire] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [cardOwner, setCardOwner] = useState('');
  const [clearInput] = useState(true);
  const trAttr = (attr) => t(`reportsAsaas.attributes.${attr}`);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  async function generateFile(type) {
    const filters = {
      start: holderName?.id ? null : dataInit,
      end: holderName?.id ? null : dataEnd,
      per_page: rowsPerPage,
      page: page + 1,
      user_id: holderName?.id || '',
      payer_name: cardOwner.id || '',
      not_used_days_after: notUsedDaysAfter,
      not_renewed_after_acquire: notRenewedAfterAcquire,
    };

    const report_name = `${moment().format('DD-MM-YYYY-HH-mm')}`;
    try {
      const rows = [];

      rows.push(['RELATÓRIO TELEVIDA ASAAS']);
      rows.push(['']);

      rows.push([
        'Data Inicial do Relatório',
        `${moment(dataInit).format('DD/MM/YYYY HH:mm')}`,
      ]);
      rows.push([
        'Data Final do Relatório',
        `${moment(dataEnd).format('DD/MM/YYYY HH:mm')}`,
      ]);
      rows.push(['']);

      rows.push([
        trAttr('holder_name'),
        trAttr('payer_name'),
        trAttr('amount'),
        trAttr('billing_type'),
        trAttr('number_of_lifes'),
        trAttr('card_number'),
        trAttr('created_at'),
        trAttr('approved_at'),
        trAttr('product'),
        trAttr('status_message'),
        trAttr('payment_id'),
      ]);
      const { data } = await Request.get('/admin/report/asaas', filters, {
        normalizeJSON: false,
      });

      data.map((row) => {
        let productsList = '';

        if(row.products_list && row.products_list.length > 0) {
          for (const prod of row.products_list) {
            productsList += `${prod.name},`;
          }
        }

        rows.push([
          row?.holder_name,
          row?.payer_name,
          formatterAmount(row.amount ),
          row?.billing_type,
          row?.number_of_lifes,
          row.card_number,
          moment(row.created_at).format('DD/MM/YYYY HH:mm:ss'),
          moment(row.approved_at).format('DD/MM/YYYY HH:mm:ss'),
          productsList,
          row.status_message,
          row.payment_id,
        ]);

        return row;
      });

      rows.push(['']);

      rows.push(['Número de vendas', reports.length]);
      rows.push(['Valor total de venda(R$)', someTotalAmount()]);

      rows.push(['']);
      rows.push(['Relatório gerado por', user.name]);
      rows.push([
        'Relatório gerado em',
        `${moment().format('L')} - ${moment().format('LT')}`,
      ]);

      if (type === 'csv') csvGenerator(`${report_name}.csv`, [...rows]);
      else xlsxGenerator(`${report_name}.xlsx`, [...rows]);

      toast.success(`Arquivo ${type.toLocaleUpperCase()} gerado com sucesso!`);
    } catch (error) {
      console.log(error);
      toast.error(
        `Não foi possível gerar o arquivo ${type.toLocaleUpperCase()}`
      );
    }
  }

  async function getReports(hasOwner) {
    let filterOwner = '';
    setLoading(true);
    if(hasOwner){
      filterOwner = cardOwner.name;
    }
    const filters = {
      start: holderName?.id ? null : dataInit,
      end: holderName?.id ? null : dataEnd,
      per_page: rowsPerPage,
      page: page + 1,
      user_id: holderName?.id || '',
      payer_name: filterOwner,
      not_used_days_after: notUsedDaysAfter,
      not_renewed_after_acquire: notRenewedAfterAcquire,
    };

    setReports([]);
    Request.get('/admin/report/asaas', filters, { normalizeJSON: false })
      .then((response) => {
        setLoading(false);
        setReports(response.data);
        setPage(toInt(response.meta.page) - 1);
        setTotalReports(toInt(response.meta.total));
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  async function fetchParams() {
    const url = new URLSearchParams(window.location.search);
    const start = url.get('start');
    const end = url.get('end');

    if (isPresent(start)) {
      const startDate = moment(start);

      if (startDate.isValid()) {
        setDataInit(startDate.format());
      }
    }

    if (isPresent(end)) {
      const endDate = moment(end);

      if (endDate.isValid()) {
        setDataEnd(endDate.format());
      }
    }
  }

  useEffect(() => {
    if (dataInit && dataEnd) {
      const hasOwnerFilter = cardOwner && cardOwner.name ? true : false;
      getReports(hasOwnerFilter);
    }
  }, [
    dataInit,
    dataEnd,
    holderName,
    cardOwner,
    notRenewedAfterAcquire,
    notUsedDaysAfter,
    page,
    rowsPerPage,
    clearInput
  ]);

  useEffect(() => {
    fetchParams();
  }, []);

  const someTotalAmount = () => {
    let some = 0;
    reports.map((item) => {
      if (item.payment_id) {
        some += Number(item.amount);
      }
    });
    return formatterAmount(some);
  };

  const formatterAmount = (value) => {
    const amount = value || 0;
    const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    return formatter.format(amount);
  };

  const renderProductList = (products) => {
    const productNames = products.map(product => product.name).join(', ');
    const displayText = products.length > 1 ? products.slice(0, 1).map(product => product.name).join(', ') + '...' : productNames;

    return (
      <Tooltip title={productNames}>
        <span className="truncated-text">{displayText}</span>
      </Tooltip>
    );
  };

  const formatterDate = (date) => {
    const formatter = moment(date).format('DD/MM/YYYY HH:mm:ss');
    return date ? formatter : '';
  };

  return (
    <>
      <Paper
        Icon={PeopleIcon}
        iconColor="blue"
        title={trAttr('reports')}
        subtitle={trAttr('reports_description')}
      >
        <GridContainer>
          <GridItem item sm={12} md={6} lg={6}>
            <InputControl
              value={holderName}
              name={'holderName'}
              label={t('reportsAsaas.attributes.holder_name')}
              inputComponent={InputSelectAsync}
              onChange={({ holderName }) => setHolderName(holderName)}
              InputProps={{
                isClearable: clearInput,
                handleFetch: fetchHolders,
                createEnabled: false,
              }}
            />
          </GridItem>
          <GridItem item sm={12} md={6} lg={6}>
            <InputControl
              value={cardOwner}
              name={'cardOwner'}
              label={t('reportsAsaas.attributes.payer_name')}
              inputComponent={InputSelectAsync}
              onChange={({ cardOwner }) => {
                  setCardOwner(cardOwner);
              }}
              InputProps={{
                isClearable: clearInput,
                handleFetch: fetchCardOwnersAssas,
                createEnabled: false,
              }}
            />
          </GridItem>

          <GridItem sm={4} md={6} lg={5}>
            <InputControl
              value={dataInit}
              name="date"
              label={t('reportsAsaas.extras.date_init')}
              inputComponent={InputDate}
              disabled={!!holderName}
              InputProps={{
                type: 'date',
              }}
              onChange={(date) => {
                if (holderName) {
                  toast.warning(
                    'Não é possível filtrar por data quando um titular está selecionado.'
                  );
                  return;
                }
                setDataInit(moment(date).startOf('day').format());
              }}
            />
          </GridItem>
          <GridItem sm={6} md={6} lg={5}>
            <InputControl
              value={dataEnd}
              name="date"
              label={t('reportsAsaas.extras.date_end')}
              inputComponent={InputDate}
              disabled={!!holderName}
              InputProps={{
                type: 'date',
              }}
              onChange={(date) => {
                if (holderName) {
                  toast.warning(
                    'Não é possível filtrar por data quando um titular está selecionado.'
                  );
                  return;
                }
                setDataEnd(moment(date).endOf('day').format());
              }}
            />
          </GridItem>
          <GridItem align="right">
            <Button
              color="second"
              onClick={() => {
                generateFile('csv');
              }}
            >
              {t('action.export_csv')} <SaveAlt />
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              color="orange"
              onClick={() => {
                generateFile('xlsx');
              }}
            >
              {t('action.export_xlsx')} <SaveAlt />
            </Button>
          </GridItem>
          <GridItem xs={12}>
            <InputSwitch
              label={t('reportsAsaas.extras.notUsedDaysAfter')}
              value={notUsedDaysAfter}
              onChange={setNotUsedDaysAfter}
            />
            <InputSwitch
              label={t('reportsAsaas.extras.notRenewedAfterAcquire')}
              value={notRenewedAfterAcquire}
              onChange={setNotRenewedAfterAcquire}
            />
          </GridItem>
        </GridContainer>

        <LinearProgress loading={loading} />

        <Table
          emptyData={reports.length === 0}
          loading={loading}
          columns={
            <>
              <TableCell className={classesTable.cell}>
                {trAttr('holder_name')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('payer_name')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('amount')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('billing_type')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('number_of_lifes')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('card_number')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('created_at')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('approved_at')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('product')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('payment_gateway')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('status_message')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('payment_id')}
              </TableCell>
            </>
          }
        >
        { reports.length > 0 &&
            reports.map((row) => {
              return (
                <TableRow
                  key={`${row?.payment_id}`}
                  hover
                  className={classesTable.row}
                >
                  <TableCell>
                    {row?.holder_name}
                  </TableCell>
                  <TableCell>{row?.payer_name}</TableCell>
                  <TableCell>
                    {formatterAmount(row?.amount)}
                  </TableCell>
                  <TableCell>
                    {row?.billing_type}
                  </TableCell>
                  <TableCell>
                    {row?.number_of_lifes}
                  </TableCell>
                  <TableCell>{row?.card_number}</TableCell>
                  <TableCell>
                    {formatterDate(row.created_at)}
                  </TableCell>
                  <TableCell>
                    {formatterDate(row.approved_at)}
                  </TableCell>
                  <TableCell>
                    {row?.products_list ? renderProductList(row.products_list) : ''}
                    </TableCell>
                  <TableCell>{row?.gateway}</TableCell>
                  <TableCell>{row?.status_message}</TableCell>
                  <TableCell>{row?.payment_id}</TableCell>
                </TableRow>
              );
            })}

        </Table>

        <LinearProgress loading={loading} />

        <TablePagination
          count={totalReports}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
}

export default ReportsAsaas;
